import { useTranslation } from "react-i18next";
import { useBookInfContext } from "components/context/bookInfContext";
import { ForwardedRef, forwardRef, useEffect, useState } from "react";
import {
  alertControl,
  dateFormat,
  diffDate,
  priceFormat,
} from "util/commAction";
import { useLocation } from "react-router-dom";
import "./bookInf.scss";

type IProps = {
  isOpen: boolean;
  inf: any;
};

const BookInfCard = (
  { isOpen, inf }: IProps,
  ref: ForwardedRef<HTMLDivElement>
) => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { bkStep, bookInf, setBkStep } = useBookInfContext();

  const start = dateFormat(bookInf?.dates[0], ". ");
  const end = dateFormat(bookInf?.dates[1], ". ");

  const diff = diffDate(bookInf?.dates || state?.dates);

  const averagePri =
    (bookInf && Math.round(bookInf.sellTotAmt / bookInf.rmTotCt)) || 0;

  // 선택된 객실이 없을 시 객실 선택 페이지 step1 으로 이동
  useEffect(() => {
    if (bkStep > 2 && !bookInf) {
      alertControl({
        isOpen: true,
        inner: "선택됱 객실이 없습니다. / 객실을 선태하여 주세요",
        click: () => {
          setBkStep(1);
        },
      });
    }
  }, [bkStep]);

  return (
    <div className="rm-inf" ref={ref}>
      {/* 객실정보 */}
      {isOpen && (
        <ul>
          <li>
            <h6>{t("txt_rm_typ_bk")}</h6>
            <h5>{bookInf?.rmNm || "-"}</h5>
          </li>
          <li>
            <h6>{t("txt_nm_gst_bk")}</h6>
            <h5>
              {t("txt_adlt_bk")}&nbsp;{inf?.adltCnt}&nbsp;{"/"}&nbsp;
              {t("txt_chld_bk")}&nbsp;
              {inf.childCnt}
            </h5>
          </li>
          <li>
            <h6>{t("txt_add_op_bk")}</h6>
            <h5>{t("txt_nan_bk")}</h5>
          </li>
        </ul>
      )}
      {/* 선택된 날짜 및 총금액 */}
      {bookInf?.sellTotAmt && (
        <ul>
          <li className="between-center">
            <h6>1{t("txt_rm_bk")}</h6>
            <h5>{priceFormat(averagePri)}</h5>
          </li>
          <li className="between-center">
            <h6>{t("txt_selected_date")}</h6>
            <h5>
              {start} ~ {end}
            </h5>
          </li>
          <li className="between-center">
            <h6>
              {" "}
              {bookInf?.rmCnt}
              {t("txt_rm_bk")} × {diff}박
            </h6>
            <h5>{priceFormat(bookInf?.sellTotAmt ?? "")}</h5>
          </li>
          <li className="between-center">
            <h6>{t("txt_dsct_bk")}</h6>
            <h5>{priceFormat(bookInf?.spPriDesc ?? 0)}</h5>
          </li>
        </ul>
      )}

      <div className="between-center">
        <h5>{t("txt_total_bk")}</h5>
        <h2 className="sub text-blue-300">
          {priceFormat(bookInf?.sellTotAmt ?? 0)}
        </h2>
      </div>
    </div>
  );
};

export default forwardRef<HTMLDivElement, IProps>(BookInfCard);
